import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Iframe from "../../Components/Addmoney/Iframe";
import { QrCkeckStatus } from "../../utils/api";
import { GlobleContaxt } from "../../Context/GlobleContaxt";
import { isEmpty } from "../../utils/common";
import AddMoneyReceipt from "../../Components/Addmoney/AddmoneyReceipt";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  text-align: center;
  font-family: Arial, sans-serif;
  background-color: #fff;
  overflow: hidden;

  .loader_ {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .message {
    margin-top: 20px;
    font-size: 18px;
    color: #333;
  }

  .highlight {
    color: #f39c12;
  }
`;






const ProcessingPage = () => {
  const [loading, setLoading] = useState(false);
  const [statusResp, setStatusResp] = useState({});
  const [statusLoading, setStatusLoading] = useState(false);
  const [timeOver, setTimeover] = useState(false);
  const navigate = useNavigate();

    const {  setRefresh, refresh ,setAlert} = useContext(GlobleContaxt);
  const timerRef = useRef(null);


  const checkstatus = (order) => {
      setStatusLoading(true);
      timerRef.current = setTimeout(() => {
        QrCkeckStatus(order).then((resp) => {
          if (resp?.success) {
            if (resp?.data.status === 'PENDING') {
              checkstatus(order);
            } else if (resp?.data.status === 'SUCCESS') {
              //setMessageResp({ type: 'success', msg: 'Payment Success', place: '' });
              localStorage.removeItem("pgData");
              setRefresh(!refresh);
              setStatusResp(resp?.data);
              // closePop();
              // clearTime();
              setLoading(false);
            } else {
              //setMessageResp({ type: 'error', msg: 'Payment Fail', place: '' });
              setStatusResp(resp?.data);
              localStorage.removeItem("pgData");
          
              clearTime();
              setLoading(false);
            }
          } else {
            setLoading(false);
            let mag = resp?.msg;
  
            if (resp?.errorCodeList?.length > 0) {
              mag = resp?.errorCodeList[0];
            }
            setAlert({ type: 'error', msg: mag });
          }
        });
      }, 3000);
    };

    useEffect(() =>{
      window.close();
  //  const data =  localStorage.getItem("pgData");
  //  console.log("data",data)
  //     if(data){
  //       const obj = JSON.parse(data);
  //       checkstatus(obj.orderId);
  //     }else{
  //       navigate("/dashboard");
  //     }
  //     return(() =>    localStorage.removeItem("pgData"));
   
    },[]);

    useEffect(() => {
 
      if (timeOver) {
        //setAlert({ type: 'info', msg: 'Your payment is pending. Please check your wallet again after some time.', place: 'globle' });
        // setQr('');
        // setTimeover(false);
        // clearTime();
        // setActiveMobilePop(false);
      }
     // return () => clearTime();
    }, [timeOver]);

    
	const clearTime = () => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}
		setStatusLoading(false);
	};

  const close = () =>{
    setStatusResp({});
    navigate("/dashboard");
  }


  return (
    <Wrapper>
   
      <div className="loader_"></div>
      <p className="message"><span className="highlight">Processing...</span></p>
      <p className="message">
        {/* You will be redirected to your bank's website. It might take a few seconds. */}
      </p>
      <p className="message">
         Please do not refresh the page or click the "Back" or "Close" button of your browser. 
      </p>
      {/* {!isEmpty(statusResp) && <AddMoneyReceipt data={statusResp} setData={close} />} */}
    </Wrapper>
  );
};

export default ProcessingPage;
